/**
 * Resource that represents a Parcel.
 *
 * @name Parcel
 * @class
 * @augments TmrResource
 */
function ParcelFactory(TmrApi, TmrResource, Transfer, Asn) {
  'ngInject'
  let actions = {
    findForInbound: {
      method: 'GET',
      url: TmrApi.endpoint('Parcel.findForInbound'),
      isArray: true,
    },
  }
  let referencedProperties = [{ property: 'asn', resource: Asn }]

  let Parcel = TmrResource('Parcel', actions, referencedProperties)
  let prevFindForInbound = Parcel.findForInbound

  Parcel.findForInbound = findForInbound
  Object.assign(Parcel.prototype, { $canDelete })

  return Parcel

  /**
   * Finds the first parcel associated to a list of epcs.
   *
   * @method Parcel#findForInbound
   * @param {string} code The parcel code.
   * @param {User} user The user for whom the parcels are retrieved.
   */
  function findForInbound(code, user) {
    if (!user || !user.place || !user.place.id) {
      throw new Error(
        'Trying to find inbound parcels but the user has no place.'
      )
    }

    return prevFindForInbound.call(this, {
      value: code,
      'asn.destinationPlace.id': user.place.id,
    })
  }

  /**
   * Verifies if this parcel has no items with transfers and so can be deleted.
   *
   * @returns {Promise<string|boolean>} If can delete, value is true; if can't delete,
   * value is a translation string for the reason.
   */
  function $canDelete() {
    let epcs = this.parcelItems.map(({ item }) => item.epc)
    if (epcs.length) {
      return Transfer.count({ 'item.epc': epcs }).then(count =>
        count ? 'RESOURCEDELETE.CANTDELETE.PARCEL' : true
      )
    }
    return Promise.resolve(true)
  }
}

export const factory = ['Parcel', ParcelFactory]
